var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.typing),expression:"typing"}],staticClass:"typing-position"},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"octadesk-chat-msg octadesk-ball-pulse-sync"},[_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }